import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { toast } from 'react-toastify';

const ESTADOS = ['prospecto','trial','activo','suspendido','cancelado'];
const EST_COLORS = { prospecto:'#6366f1', trial:'#fbbf24', activo:'#34d399', suspendido:'#f97316', cancelado:'#f87171' };
const fmt = (n) => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(n || 0);

const Badge = ({ estado }) => (
  <span style={{
    padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600,
    background: (EST_COLORS[estado] || '#64748b') + '22',
    color: EST_COLORS[estado] || '#64748b',
    textTransform: 'capitalize'
  }}>{estado}</span>
);

export default function AdminClientes() {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('');
  const [estadoFiltro, setEstadoFiltro] = useState('');
  const [modal, setModal] = useState(null); // null | 'nuevo' | objeto_cliente
  const navigate = useNavigate();

  const cargar = () => {
    api.get('/admin/clientes').then(r => setClientes(r.data)).finally(() => setLoading(false));
  };
  useEffect(cargar, []);

  const clientesFiltrados = clientes.filter(c => {
    const q = filtro.toLowerCase();
    const matchTexto = !q || c.empresa?.toLowerCase().includes(q) || c.email?.toLowerCase().includes(q) || c.ciudad?.toLowerCase().includes(q);
    const matchEstado = !estadoFiltro || c.estado === estadoFiltro;
    return matchTexto && matchEstado;
  });

  return (
    <div style={{ padding: 28 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: 'var(--text-1)' }}>Clientes SaaS</h1>
          <p style={{ margin: '4px 0 0', color: 'var(--text-3)', fontSize: 14 }}>{clientes.length} empresas registradas</p>
        </div>
        <button
          onClick={() => setModal({ nuevo: true })}
          style={{ padding: '9px 20px', borderRadius: 8, border: 'none', background: '#6366f1', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}
        >
          + Nuevo Cliente
        </button>
      </div>

      {/* Filters */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
        <input
          placeholder="Buscar empresa, email, ciudad..."
          value={filtro}
          onChange={e => setFiltro(e.target.value)}
          style={{ flex: 1, padding: '9px 14px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg-card)', color: 'var(--text-1s)', fontSize: 14, outline: 'none' }}
        />
        <select
          value={estadoFiltro}
          onChange={e => setEstadoFiltro(e.target.value)}
          style={{ padding: '9px 14px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg-card)', color: 'var(--text-1s)', fontSize: 14, outline: 'none' }}
        >
          <option value="">Todos los estados</option>
          {ESTADOS.map(e => <option key={e} value={e}>{e}</option>)}
        </select>
      </div>

      {/* Table */}
      {loading ? (
        <div style={{ textAlign: 'center', color: 'var(--text-3)', padding: 60 }}>Cargando...</div>
      ) : (
        <div style={{ background: 'var(--bg-card)', borderRadius: 12, border: '1px solid var(--border)', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: 'var(--bg-app)' }}>
                {['Empresa','Contacto','Ciudad','Plan Actual','Sillas','Total Pagado','Estado',''].map(h => (
                  <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 600, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: 0.5 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {clientesFiltrados.map(c => (
                <tr key={c.id} style={{ borderTop: '1px solid var(--border)', cursor: 'pointer', transition: 'background 0.1s' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#0f172a'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                  onClick={() => navigate(`/superadmin/clientes/${c.id}`)}
                >
                  <td style={{ padding: '14px 16px' }}>
                    <div style={{ fontWeight: 600, color: 'var(--text-1)', fontSize: 14 }}>{c.empresa}</div>
                    <div style={{ color: 'var(--text-3)', fontSize: 12 }}>{c.email}</div>
                  </td>
                  <td style={{ padding: '14px 16px' }}>
                    <div style={{ color: 'var(--text-1s)', fontSize: 13 }}>{c.contacto_nombre || '-'}</div>
                    <div style={{ color: 'var(--text-3)', fontSize: 12 }}>{c.contacto_cargo}</div>
                  </td>
                  <td style={{ padding: '14px 16px', color: 'var(--text-2)', fontSize: 13 }}>{c.ciudad || '-'}</td>
                  <td style={{ padding: '14px 16px', color: 'var(--text-1s)', fontSize: 13 }}>{c.plan_actual || '-'}</td>
                  <td style={{ padding: '14px 16px', color: 'var(--text-1s)', fontSize: 13, textAlign: 'center' }}>{c.sillas_actuales || '-'}</td>
                  <td style={{ padding: '14px 16px', color: '#22d3ee', fontSize: 13, fontWeight: 600 }}>{fmt(c.total_pagado)}</td>
                  <td style={{ padding: '14px 16px' }}><Badge estado={c.estado} /></td>
                  <td style={{ padding: '14px 16px' }}>
                    <button
                      onClick={e => { e.stopPropagation(); setModal(c); }}
                      style={{ padding: '5px 12px', borderRadius: 6, border: '1px solid var(--border)', background: 'transparent', color: 'var(--text-2)', cursor: 'pointer', fontSize: 12 }}
                    >
                      Editar
                    </button>
                  </td>
                </tr>
              ))}
              {!clientesFiltrados.length && (
                <tr><td colSpan={8} style={{ padding: 40, textAlign: 'center', color: 'var(--text-4)' }}>No hay clientes</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {modal && <ClienteModal data={modal.nuevo ? null : modal} onClose={() => setModal(null)} onSaved={() => { setModal(null); cargar(); }} />}
    </div>
  );
}

function ClienteModal({ data, onClose, onSaved }) {
  const esNuevo = !data;
  const [form, setForm] = useState({
    empresa: data?.empresa || '',
    nit: data?.nit || '',
    email: data?.email || '',
    telefono: data?.telefono || '',
    ciudad: data?.ciudad || '',
    pais: data?.pais || 'Colombia',
    contacto_nombre: data?.contacto_nombre || '',
    contacto_cargo: data?.contacto_cargo || '',
    estado: data?.estado || 'prospecto',
    notas: data?.notas || '',
  });
  const [saving, setSaving] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const guardar = async () => {
    if (!form.empresa || !form.email) return toast.error('Empresa y email son requeridos');
    setSaving(true);
    try {
      if (esNuevo) {
        await api.post('/admin/clientes', form);
        toast.success('Cliente creado');
      } else {
        await api.put(`/admin/clientes/${data.id}`, form);
        toast.success('Cliente actualizado');
      }
      onSaved();
    } catch (e) {
      toast.error(e.response?.data?.error || 'Error al guardar');
    } finally {
      setSaving(false);
    }
  };

  const eliminar = async () => {
    if (!window.confirm('¿Eliminar cliente? Solo funciona si no tiene suscripciones activas.')) return;
    try {
      await api.delete(`/admin/clientes/${data.id}`);
      toast.success('Cliente eliminado');
      onSaved();
    } catch (e) {
      toast.error(e.response?.data?.error || 'Error');
    }
  };

  const inputStyle = {
    width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid var(--border)',
    background: 'var(--bg-app)', color: 'var(--text-1s)', fontSize: 13, outline: 'none', boxSizing: 'border-box'
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#00000080', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
      <div style={{ background: 'var(--bg-card)', borderRadius: 16, padding: 28, width: '100%', maxWidth: 560, border: '1px solid var(--border)', maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h2 style={{ margin: 0, fontSize: 18, color: 'var(--text-1)' }}>{esNuevo ? 'Nuevo Cliente' : 'Editar Cliente'}</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-3)', cursor: 'pointer', fontSize: 20 }}>×</button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
          <div style={{ gridColumn: '1/-1' }}>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Empresa *</label>
            <input style={inputStyle} value={form.empresa} onChange={e => set('empresa', e.target.value)} placeholder="Nombre de la empresa" />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>NIT</label>
            <input style={inputStyle} value={form.nit} onChange={e => set('nit', e.target.value)} placeholder="900.123.456-1" />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Email *</label>
            <input style={inputStyle} type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="admin@empresa.com" />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Teléfono</label>
            <input style={inputStyle} value={form.telefono} onChange={e => set('telefono', e.target.value)} placeholder="3001234567" />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Ciudad</label>
            <input style={inputStyle} value={form.ciudad} onChange={e => set('ciudad', e.target.value)} placeholder="Bogotá" />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Contacto</label>
            <input style={inputStyle} value={form.contacto_nombre} onChange={e => set('contacto_nombre', e.target.value)} placeholder="Nombre del contacto" />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Cargo</label>
            <input style={inputStyle} value={form.contacto_cargo} onChange={e => set('contacto_cargo', e.target.value)} placeholder="Gerente, CEO..." />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Estado</label>
            <select style={inputStyle} value={form.estado} onChange={e => set('estado', e.target.value)}>
              {ESTADOS.map(e => <option key={e} value={e}>{e}</option>)}
            </select>
          </div>
          <div style={{ gridColumn: '1/-1' }}>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Notas</label>
            <textarea style={{ ...inputStyle, minHeight: 70, resize: 'vertical' }} value={form.notas} onChange={e => set('notas', e.target.value)} placeholder="Observaciones..." />
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 24 }}>
          {!esNuevo && (
            <button onClick={eliminar} style={{ padding: '9px 18px', borderRadius: 8, border: '1px solid #f87171', background: 'transparent', color: '#f87171', cursor: 'pointer', fontSize: 13 }}>
              Eliminar
            </button>
          )}
          <div style={{ display: 'flex', gap: 10, marginLeft: 'auto' }}>
            <button onClick={onClose} style={{ padding: '9px 18px', borderRadius: 8, border: '1px solid var(--border)', background: 'transparent', color: 'var(--text-2)', cursor: 'pointer', fontSize: 13 }}>
              Cancelar
            </button>
            <button onClick={guardar} disabled={saving} style={{ padding: '9px 20px', borderRadius: 8, border: 'none', background: '#6366f1', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>
              {saving ? 'Guardando...' : 'Guardar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
